/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum IciFlags {
    UNKNOWN = 0,
    INBOUND = 1,
    OUTBOUND = 2,
    INTERNAL = 4,
    EXTERNAL = 8,
    BUSY = 16,
    NO_ANSWER = 32,
    CONFERENCE = 64,
    FORWARDED = 128,
    FALLBACK = 256,
    TRANSFERRED = 512,
    INTERPOSITION = 1024,
    PARK_PRIVATE = 2048,
    PARK_PUBLIC = 4096,
    LOCAL_CALL = 8192,
    FREE_OPERATOR_SET = 16384,
    PENDING = 32768,
    REJECTED = 65536,
    EMERGENCY = 131072,
    CALLBACK = 262144,
    RECORDING = 524288,
}
